<template>
  <transition name="slide-up">
    <div
      class="horizontal-menu pr0 col-sm-12 pl0 carousel-pr-12"
      :class="[clientPlatform == 'Web' ? 'mb15' : 'mb24']"
      v-if="!showFetchLocationModal"
    >
      <div class="catg-header" v-if="ProductCategoryData?.length">
        <div>
          <span class="fs-16 tc fw-700 color-slaty-dark">{{ title }}</span>
          <lazy-image alt="default image" :src="titleImg" class="pl5" />
        </div>
        <!-- <div class="d-flex" @click="toggleVegOnly">
        <img
          :src="staticImgBaseUrl + '/images/global/enableToggleMap.svg'"
          alt="toggle-icon"
          v-if="isVegOnly"
        />
        <img
          :src="staticImgBaseUrl + '/images/global/disableToggleMap.svg'"
          alt="toggle-icon"
          v-else
        />
        <div class="d-flex flex-column">
          <span class="fs-11 fw-700">Veg</span
          ><span class="fs-10 fw-500">only</span>
        </div>
      </div> -->
      </div>
      <div
        class="catg-header"
        v-else-if="!ProductCategoryData?.length && isLoading"
      >
        <div class="">
          <span
            class="hide-shimmer-text shimmer-container rounded p2 fs-16 text-transparent"
          >
            random category header
          </span>
          <span
            class="hide-shimmer-text shimmer-container rounded ml8 p2 fs-16 text-transparent"
            >title img</span
          >
        </div>
      </div>
      <ul class="grid-view pt16" v-if="ProductCategoryData?.length">
        <li v-for="(banner, index) in ProductCategoryData" :key="index">
          <div
            class="d-flex flex-wrap cursor-pointer align-items-center"
            @click="handleMenuCategoryClicked(banner, index)"
          >
            <div class="grid-menu-img-wrap" :style="getImgBgColor(banner)">
              <span
                class="fs-14 fw-800 tc cat-name bold"
                :class="{ active: isActive }"
                :style="[getTextColor(banner), getDelayStyle(index)]"
              >
                {{ categoryName(banner) }}
              </span>

              <img
                class="flex-row img-category-menu"
                :class="{ active: isActive }"
                :style="getDelayStyle(index)"
                alt="default image"
                :src="getImageUrl(banner)"
              />
            </div>
          </div>
        </li>
      </ul>
      <product-category-grid-shimmer
        v-else-if="!ProductCategoryData?.length && isLoading"
      ></product-category-grid-shimmer>
    </div>
  </transition>
</template>

<script setup>
import LazyImage from "./LazyImage.vue";
import ProductCategoryGridShimmer from "./ProductCategoryGridShimmer.vue";
</script>

<script>
import {
  staticImgBaseUrl,
  imgBaseUrl,
  clientPlatform,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import { keyMapsMutation } from "../helpers/storeKeys";
import localStorageFunc from "../helpers/localStorageFunc";
import {
  EVENT_EXPLORE_MENU_CATEGORY_CLICK,
  EVENT_MENU_CATEGORY_SELECTED,
} from "../helpers/analyticsEvents";
import { OrderTypesFromCode } from "../helpers/orderTypesConstants";

export default {
  name: "ProductCategoryGrid",
  props: { dataResults: {}, moduleProps: {} },
  data() {
    return {
      clientPlatform,
      ProductCategoryData: [],
      modulePropsData: {},
      staticImgBaseUrl: staticImgBaseUrl,
      imgBaseUrl: imgBaseUrl,
      showMoreEnabled: false,
      showSubCategoryMenu: false,
      parsedResults: [],
      showMoreText: "Show More",
      showLessText: "Show Less",
      hideCategoryIds: [],
      title: "",
      titleImg: "",
      isVegOnly: false,
      isActive: false,
      isLoading: true,
    };
  },
  mounted() {
    this.parsedResults = Utility.tryJsonParse(this.dataResults, []);
    // this.$store.commit(
    //   keyMapsMutation.UPDATE_PRODUCT_CATEGORY,
    //   this.parsedResults?.menuHierarchyData
    // );
    // this.$store.commit(
    //   keyMapsMutation.UPDATE_IMG_BASE_URL,
    //   this.parsedResults?.mediaBaseURL
    // );
    // this.modulePropsData = Utility.tryJsonParse(this.moduleProps, {
    //   titleKey: "nodeName",
    //   thumbnailImageKey: "mediaList[0].mediaUrls.thumbnail",
    // });
    // this.hideCategoryIds =
    //   Utility.tryJsonParse(
    //     this.modulePropsData?.hideCategoryIds?.replace(/'/g, '"'),
    //     []
    //   ) || [];
    // this.ProductCategoryData = this.parsedResults?.menuHierarchyData?.slice(
    //   0,
    //   this.modulePropsData?.menuItemsToShowUpfront
    // );
    // if (Array.isArray(this.hideCategoryIds)) {
    //   this.ProductCategoryData = this.ProductCategoryData?.filter(
    //     (x) =>
    //       !this.hideCategoryIds.find(
    //         (y) => y === x.metadataMap.categoryId.values[0]
    //       )
    //   );
    // }
    this.modulePropsData =
      typeof this.moduleProps != null &&
      typeof this.moduleProps != "null" &&
      typeof this.moduleProps != "undefined"
        ? JSON.parse(this.moduleProps)
        : {};

    this.title = this.modulePropsData?.title;
    this.titleImg = this.modulePropsData?.titleImg;
    this.ProductCategoryData = this.parsedResults?.[0]?.data;
    this.clientPlatform !== "Web" &&
      this.$store.commit(
        keyMapsMutation.UPDATE_PRODUCT_CATEGORY,
        this.parsedResults?.[0]?.data,
      );
    setTimeout(() => (this.isActive = true), 3100);
    setTimeout(() => (this.isLoading = false), 3000);
  },
  methods: {
    handleShowMoreClicked(e) {
      this.showMoreEnabled = !this.showMoreEnabled;
      if (this.showMoreEnabled) {
        this.ProductCategoryData = this.parsedResults?.menuHierarchyData;
      } else {
        this.ProductCategoryData = this.parsedResults?.menuHierarchyData?.slice(
          0,
          this.modulePropsData?.menuItemsToShowUpfront,
        );
      }
      if (Array.isArray(this.hideCategoryIds)) {
        this.ProductCategoryData = this.ProductCategoryData?.filter(
          (x) =>
            !this.hideCategoryIds.find(
              (y) => y === x.metadataMap.categoryId.values[0],
            ),
        );
      }
    },
    scrollToCategoryId(item, url) {
      if (item) {
        const categoryId =
          item?.metadataMap?.categoryId?.values[0] || "menuTop";
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        return Utility.addUpdateParam(url, "scrollTo", categoryId);
      }
      return url;
    },
    toggleVegOnly() {
      this.isVegOnly = !this.isVegOnly;
    },
    getDelayStyle(index, type) {
      if (!this.isActive) return {};

      const base = index * 150;
      return {
        transitionDelay: type === "img" ? `${base + 100}ms` : `${base}ms`,
      };
    },
    handleMenuCategoryClicked(item, index) {
      // if (window.location.href?.includes("/popeyes")) {
      //   if (this.checkSubCategoryTrigger(item)) {
      //     this.$store.commit(
      //       keyMapsMutation.UPDATE_SHOW_SUB_CATEGORY_DATA,
      //       item?.children?.filter((_) => _.type === "NON_LEAF")
      //     );
      //     this.$store.commit(
      //       keyMapsMutation.UPDATE_SHOW_SUB_CATEGORY_MODAL,
      //       true
      //     );
      //   } else {
      //     this.scrollto({ nodeId: item?.nodeId });
      //   }
      // } else {
      EVENT_MENU_CATEGORY_SELECTED({
        sectionPosition: index + 1,
        category: this.categoryName(item),
        gridSize: "3*3",
      });
      EVENT_EXPLORE_MENU_CATEGORY_CLICK({
        eventAction: "Go to Coupon Page",
        positionWithinSection: index + 1,
        category: this.categoryName(item),
        subcategory: OrderTypesFromCode[this.currentOrderType],
      });
      this.goto(item); //above code is for home page menu
      // }
    },
    getImageUrl(banner) {
      return banner.categoryImages?.find(
        (x) => x.mediaSize === "tAppCategory" || x.mediaSize === "CategoriesV1",
      )?.mediaPath;
    },
    checkSubCategoryTrigger(item) {
      if (
        item?.children?.length > 0 &&
        item?.children?.filter((_) => _.type === "NON_LEAF")?.length
      ) {
        return true;
      }
      return false;
    },
    goto(item) {
      let url =
        projectBasePathWithFolder +
        "/menu/" +
        localStorageFunc.storeId() +
        Utility.getUrlQueryString();
      url = this.scrollToCategoryId(item, url);
      window.location.href = url;
    },
    scrollto({ index, nodeId, categoryName }) {
      Utility.gotoElement({ id: nodeId });
    },
    categoryName(banner) {
      return banner.title?.split("_").join(" ");
    },
    getImgBgColor(banner) {
      return { backgroundColor: banner?.metadataMap?.bgColor?.values?.[0] };
    },
    getTextColor(banner) {
      return { color: banner?.metadataMap?.textColor?.values?.[0] };
    },
  },
  computed: {
    getBottomBarData() {
      return this.$store.state.ProductItems.productItems;
    },
    // showMoreOrLessText() {
    //   return this.showMoreEnabled
    //     ? this.modulePropsData?.showLessText
    //     : this.modulePropsData?.showMoreText;
    // },
    currentOrderType() {
      return this.$store.state.User.currentOrderType;
    },
    showFetchLocationModal() {
      return this.$store.state.Location.showFetchLocationModal;
    },
  },
};
</script>
